<template>
  <div class="c-micro-application">
    <div class="c-micro-application__title">微应用</div>
    <div class="c-micro-application__warp">
      <div
        v-for="(item, index) in miniAppList"
        :key="index"
        class="c-micro-application__item"
        @click="clickItem(item)"
      >
        <div class="c-micro-application__item__content">
          <img class="c-micro-application__item__bg" :src="item.icon" />
          <div class="c-micro-application__item__name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      appInfo: state => state.product.appInfo,
    }),
    miniAppList() {
      const miniappList = [].concat(this.appInfo.miniapp || [])
      return miniappList
    }
  },
  methods: {
    clickItem(item) {
      this.$emit('click-item', item)
    },
  }
}
</script>

<style lang="scss">
.c-micro-application {
  background-color: #fff;
  padding: 0.26rem;
  .c-micro-application__title {
    font-size: 16px;
    font-weight: bold;
  }
  .c-micro-application__warp {
    padding-top: 0.3rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: -10px;
    .c-micro-application__item {
      text-align: center;
      width: 16%;
      margin-bottom: 10px;
      .c-micro-application__item__content {
        display: inline-block;
        cursor: pointer;
        .c-micro-application__item__bg {
          width: 60px;
          height: 60px;
        }
        .c-micro-application__item__name {
          font-size: 0.16rem;
          font-weight: 600;
          color: #333333;
          line-height: 0.48rem;
        }
      }
    }
  }
}
</style>
